import { z } from 'zod';

/** Listenabfrage laut Plan 01 Abschnitt 4: ?q=&sort=&order=&page=&pageSize=&filter[state]=NW */
export const ListQuerySchema = z.object({
  q: z.string().optional(),
  sort: z.string().optional(),
  order: z.enum(['asc', 'desc']).optional(),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(500).default(50),
  filters: z.record(z.union([z.string(), z.array(z.string())])).default({}),
});
export type ListQuery = z.infer<typeof ListQuerySchema>;

/** Liest eine Query-String-Map (z. B. aus Fastify oder URLSearchParams) in eine ListQuery. */
export function parseListQuery(raw: Record<string, unknown>): ListQuery {
  const filters: Record<string, string | string[]> = {};
  const rest: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(raw)) {
    const m = /^filter\[(.+)\]$/.exec(k);
    if (m) {
      const key = m[1]!;
      if (Array.isArray(v)) filters[key] = v.map(String);
      else if (typeof v === 'string' && v.includes(',')) filters[key] = v.split(',').filter(Boolean);
      else if (v != null && v !== '') filters[key] = String(v);
    } else rest[k] = v;
  }
  return ListQuerySchema.parse({ ...rest, filters });
}

/** Baut die Query-Parameter für einen Listenaufruf (Frontend). */
export function listQueryToParams(q: Partial<ListQuery>): URLSearchParams {
  const p = new URLSearchParams();
  if (q.q) p.set('q', q.q);
  if (q.sort) p.set('sort', q.sort);
  if (q.order) p.set('order', q.order);
  if (q.page && q.page !== 1) p.set('page', String(q.page));
  if (q.pageSize) p.set('pageSize', String(q.pageSize));
  for (const [k, v] of Object.entries(q.filters ?? {})) {
    if (Array.isArray(v)) {
      if (v.length) p.set(`filter[${k}]`, v.join(','));
    } else if (v) p.set(`filter[${k}]`, v);
  }
  return p;
}
